import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";

export default function Pagination({ page, totalPages, total, pageSize, onPageChange }) {
  if (!total || totalPages <= 1) return null;

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className="flex items-center justify-between pt-4" data-testid="pagination">
      <p className="text-xs text-muted-foreground">
        {start}–{end} de {total}
      </p>
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="icon" className="h-8 w-8" disabled={page <= 1}
          data-testid="pagination-first" onClick={() => onPageChange(1)}>
          <ChevronsLeft className="w-4 h-4" />
        </Button>
        <Button variant="ghost" size="icon" className="h-8 w-8" disabled={page <= 1}
          data-testid="pagination-prev" onClick={() => onPageChange(page - 1)}>
          <ChevronLeft className="w-4 h-4" />
        </Button>
        <span className="text-xs font-medium px-3 min-w-[80px] text-center" data-testid="pagination-info">
          {page} / {totalPages}
        </span>
        <Button variant="ghost" size="icon" className="h-8 w-8" disabled={page >= totalPages}
          data-testid="pagination-next" onClick={() => onPageChange(page + 1)}>
          <ChevronRight className="w-4 h-4" />
        </Button>
        <Button variant="ghost" size="icon" className="h-8 w-8" disabled={page >= totalPages}
          data-testid="pagination-last" onClick={() => onPageChange(totalPages)}>
          <ChevronsRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
